<app-loading-animation *ngIf="isLoading"></app-loading-animation>
<div class="table-container">
  <div class="table-wrapper" >
    <table class="table table-bordered">
      <thead>
      <tr>
        <th class="column-1">
          <div class="th-content">
            <p>МНН</p>
          </div>
        </th>
        <th class="column-2">
          <div class="th-content">
            <p>Дозування</p>
          </div>
        </th>
        <th class="column-3">
          <app-filter
              [key]="'tradeNameUnique'"
              (selectedOptionsChange)="applyFilters($event)"
              [reset]="resetFilters"
          >
            Торгова назва
          </app-filter>
        </th>
        <th class="column-4">
<!--          <app-filter-->
<!--              [key]="'tradeNameUnique'"-->
<!--              (selectedOptionsChange)="applyFilters($event)"-->
<!--              [reset]="resetFilters"-->
<!--          >-->
<!--            Статус-->
<!--          </app-filter>-->
          <div class="th-content"><p>Статус</p></div>
        </th>
        <th class="column-5">
          <div class="th-content">
            <p>Напрям</p>
          </div>
        </th>
        <th class="column-6">
          <div class="th-content"><p>Кількість у запиті</p></div>
        </th>
        <th class="column-7">
          <div class="th-content"><p>Доступно для пропозиції</p></div>
        </th>
        <th class="column-8">
          <div class="th-content"><p>Назва закладу</p></div>
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="!errorCode">
        <tr
            *ngFor=" let request of requests"
            (click)="onRowClick(request.id)"
        >
          <td class="column-1">{{ request.mnn }}</td>
          <td class="column-2">{{ request.dosage === null ? '-' : request.dosage }}</td>
          <td class="column-3">{{ request.tradeName }}</td>
          <td class="column-4"><app-redistribution-status [status]="request.status"/></td>
          <td class="column-5">{{ request.direction === null ? '-' : request.direction }}</td>
          <td class="column-6">{{ request.amount === null ? '-' : request.amount}}</td>
          <td class="column-7">{{ request.leftover === null ? '-' : request.leftover}}</td>
          <td class="column-8">{{ getOrganisationName(request.organizationId) }}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!errorCode && requests.length === 0 && !isLoading">
        <tr>
          <td [attr.colspan]="8">
            <div class="error-cell-content">
              <app-error
                  [errorCode]="404"
              />
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="errorCode">
        <tr>
          <td [attr.colspan]="8">
            <div class="error-cell-content">
              <app-error [errorCode]="errorCode"></app-error>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="table-footer">
    <div class="left">
      <strong>Застосовані фільтри</strong> <span>{{ filterCount }}</span>
      <div (click)="onResetFilters()" class="icon-container">
        <med-icon-reset class="icon" size="16"></med-icon-reset>
      </div>
    </div>
    <div class="right">
      <med-pagination
          *ngIf="requests.length > 0"
          (pageChange)="onPageChange($event)"
          [page]="pagination.page"
          [perPage]="pagination.perPage"
          [total]="pagination.totalElements"
      ></med-pagination>
    </div>
  </div>
</div>